import { Injectable, computed, signal } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class DebugDrawerStateService {
  private readonly isEnabled = signal(false);
  readonly isAvailable = environment.showDebugDrawer;
  readonly isVisible = computed(() => this.isAvailable && this.isEnabled());

  toggle(): void {
    this.isEnabled.update((enabled) => !enabled);
  }
}
